<div class="column serving">
    <div class="cell">
        @if (score.currentlyServing === 1) {
            <span class="serving-indicator"></span>
        }
    </div>
    <div class="cell">
        @if (score.currentlyServing === 2) {
            <span class="serving-indicator"></span>
        }
    </div>
</div>
@if (sitecoreEventDetailsVM$ | async; as sitecoreEventDetailsVM) {
    @if (sets && score.matchType === matchType.SetsAndLegs) {
        @if (sets && score.matchType === matchType.SetsAndLegs) {
            <div class="column sets">
                <div class="cell">
                    <div [msValueSlider]="sets.participant1.toString()"></div>
                </div>
                <div class="cell">
                    <div [msValueSlider]="sets.participant2.toString()"></div>
                </div>
                @if (!hideScoreBoardColumnFooter) {
                    <div class="cell">{{ sitecoreEventDetailsVM.sets }}</div>
                }
            </div>
        }
    }
    @if (legs) {
        <div class="column legs">
            <div class="cell">
                <div [msValueSlider]="legs.participant1.toString()"></div>
            </div>
            <div class="cell">
                <div [msValueSlider]="legs.participant2.toString()"></div>
            </div>
            @if (!hideScoreBoardColumnFooter) {
                <div class="cell">{{ sitecoreEventDetailsVM.legs }}</div>
            }
        </div>
    }
}
